module.exports = __webpack_public_path__ + "img/icon-change-pay.ac9c285e.svg";